import { Container, styled, Typography, Box, Grid } from "@mui/material";
import React from "react";
import aboutImage from "../../images/overviewimg.webp"; // Replace with the actual image path

// Styled Components
const Description = styled(Typography)({
  fontFamily: "Poppins",
  fontWeight: "normal",
  lineHeight: 1.8,
  opacity: 0.8,
  color: "#555",
  textAlign: "left",
});

const SectionContainer = styled(Box)({
  margin: "40px 0",
});

const AboutUs = () => {
  return (
    <Container maxWidth="xl" sx={{ marginTop: 10, padding: { xs: 2, md: 4 } }}>
      <Typography
        variant="h3"
        textAlign={"center"}
        sx={{
          fontFamily: "Poppins",
          fontWeight: "bold",
          lineHeight: 1.5,
          opacity: 0.7,
        }}
      >
        About Us
      </Typography>
      <Grid container spacing={4} alignItems="center">
        {/* Left Side - Text Content */}
        <Grid item xs={12} md={6}>
          {/* <SectionContainer>
            <Description variant="h5" fontWeight="bold">
              I am Lakshmi Anand, founder of Prana Yoga and Meditation in
              Naperville, IL.
            </Description>
            <Description variant="body1">
              A place of Holistic therapy, a form of healing that considers a
              person as a whole, treating the body by Yoga Asanas, Mind by
              Pranayama, and Emotions by Meditation & Spirit.
            </Description>
            <Description variant="body1">
              As part of my wellness journey, I have over 7 years of experience.
              I have completed over 200 hours of Yoga Alliance-certified
              training in Hatha and Ashtanga Yoga from Subra School of Yoga in
              Chicago, IL.
            </Description>
            <Description variant="body1">
              Diploma Yoga Therapy over 500 hours from Chennai, India,
              Meditation and Hypnosis, Residential course from Aum Holistic
              Healing Center, Cochin Kerala, India.
            </Description>
            <Description variant="body1">
              I teach people how to breathe and live a stress-free & happy life.
            </Description>
            <Description variant="body1">
              In today’s life, when we are running to keep up with our desires
              and don’t have enough time for our health, Yoga and Meditation
              bring you interesting sessions to help you feel relaxed,
              enthusiastic, and energetic to perform daily rituals in a better
              way.
            </Description>
            <Description variant="body1">
              I love everything that comes from this practice—getting to know my
              students, meeting new people, and gaining relationships. With the
              peace I have received from yoga, I am passionate about creating
              that same opportunity for Corporates, Schools, and Colleges.
            </Description>
            <Description variant="body1">
              Conducting Corporate Sessions helps professionals stay healthy and
              energetic, reducing fatigue and improving productivity. I also
              provide private consultations with a mindful approach,
              specializing in stress-related conditions like burnout, adrenal
              fatigue, IBS, insomnia, depression, anxiety, weight loss, and
              overall fitness.
            </Description>
            <Description variant="body1">
              I help people overcome stress, anxiety, hypertension, depression,
              and psychosomatic disorders, delivering guided one-to-one coaching
              and support to help them reach their health and fitness goals.
            </Description>
          </SectionContainer> */}
          <SectionContainer>
            <Typography
              variant="h5"
              fontWeight="bold"
              sx={{
                fontFamily: "Poppins",
                color: "#4B2E83", // Deep purple tone
                marginBottom: 2,
              }}
            >
              Meet Lakshmi Anand —
            </Typography>

            <Typography
              variant="body1"
              sx={{
                fontSize: "1.1rem",
                fontWeight: 500,
                color: "#444",
                marginBottom: 2,
              }}
            >
              Founder of <strong>Prana Yoga & Meditation</strong>, Naperville,
              IL — a serene space for mind, body & emotional healing.
            </Typography>

            <Typography variant="body1" sx={{ marginBottom: 2, opacity: 0.85 }}>
              With <strong>7+ years of experience</strong> and{" "}
              <strong>
                700+ hours of certified training, including a Diploma in Yoga
                Therapy
              </strong>{" "}
              from India & the US, I guide individuals through{" "}
              <strong>Yoga Asanas</strong>, <strong>Pranayama</strong>, and{" "}
              <strong>Meditation</strong>. I am also trained in{" "}
              <strong>Past Life Regression Therapy</strong> from a reputed
              institute, helping individuals explore deeper emotional patterns
              and healing pathways.
            </Typography>

            <Typography variant="body1" sx={{ marginBottom: 2 }}>
              Whether you're facing burnout, stress, or simply seeking inner
              balance, my sessions are designed to help you feel{" "}
              <span style={{ color: "#7C3AED", fontWeight: 600 }}>
                relaxed, renewed, and recharged
              </span>
              .
            </Typography>

            <Typography variant="body1" sx={{ marginBottom: 2 }}>
              From <strong>corporate programs</strong> to{" "}
              <strong>private consultations</strong>, every session is tailored
              with empathy and mindfulness to transform your lifestyle.
            </Typography>

            <Typography
              variant="body1"
              sx={{
                fontWeight: 600,
                fontStyle: "italic",
                color: "#2e7d32",
              }}
            >
              Let's breathe, move, and heal — together.
            </Typography>
          </SectionContainer>
        </Grid>

        {/* Right Side - Image */}
        <Grid item xs={12} md={6}>
          <Box
            component="img"
            src={aboutImage}
            alt="About Us"
            sx={{
              width: "60%",
              borderRadius: "10px",
              boxShadow: "0 4px 10px rgba(0,0,0,0.2)",
            }}
          />
        </Grid>
      </Grid>
    </Container>
  );
};

export default AboutUs;
